// MUI's Modal sets aria-hidden on #root while a dialog is open, which silences anything announced from
// outside it (e.g. the toast container). Each open dialog mounts a <LiveRegion /> that registers here, and
// announce() routes to the top-most one. With no dialog open it returns false: the caller's own
// role="status"/"alert" element is already audible.
const handlers = [];

export const registerLiveRegion = (handler) => {
  handlers.push(handler);

  return () => {
    const index = handlers.indexOf(handler);
    if (index >= 0) handlers.splice(index, 1);
  };
};

export const announce = (message, politeness = "polite") => {
  const handler = handlers[handlers.length - 1];

  if (!handler || !message) return false;

  handler(message, politeness);
  return true;
};
